export default {
  HIDE_WIZARD: 'hide_site_creation_wizard',
  SET_SESSION_INITIALIZED_WITH_WIZARD: 'set_session_initialized_with_wizard',
  SET_SITE_CREATION_FINISHED: 'set_site_creation_finished',
  SET_SITE_CREATION_FULLY_DONE: 'set_site_creation_fully_done',
};
